export default __webpack_public_path__ + "static/media/Two countries.dcc653e7.mp4";